import type { ComponentProps, PointerEvent } from 'react'

// Card whose border and interior glow track the cursor (see `.spot` in
// application.css). Position goes through CSS variables so pointer moves
// never trigger a React render.
export function SpotlightCard({ className = '', onPointerMove, ...props }: ComponentProps<'div'>) {
  const handleMove = (e: PointerEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect()
    e.currentTarget.style.setProperty('--mx', `${e.clientX - rect.left}px`)
    e.currentTarget.style.setProperty('--my', `${e.clientY - rect.top}px`)
    onPointerMove?.(e)
  }

  return (
    <div
      {...props}
      onPointerMove={handleMove}
      className={`spot rounded-3xl border border-border bg-card/50 backdrop-blur-sm ${className}`}
    />
  )
}
